import React, { useState } from 'react';
import OrderModal from './OrderModal';


function App() {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#1a1a1a', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center' 
    }}>
      <button
        onClick={() => setOpen(true)}
        style={{
          background: '#C9A052',
          color: '#0A0A0A',
          padding: '16px 40px',
          border: 'none',
          borderRadius: '9999px',
          fontSize: '1.1rem',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        Jetzt bestellen
      </button>

      <OrderModal isOpen={open} onClose={() => setOpen(false)} />
    </div>
  );
}

export default App;
